import { render, staticRenderFns } from "./SSOAccountSyncronizeView.vue?vue&type=template&id=0082cdc4&scoped=true"
import script from "./SSOAccountSyncronizeView.vue?vue&type=script&lang=ts"
export * from "./SSOAccountSyncronizeView.vue?vue&type=script&lang=ts"
import style0 from "./SSOAccountSyncronizeView.vue?vue&type=style&index=0&id=0082cdc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0082cdc4",
  null
  
)

export default component.exports